import { css } from 'styled-components';
export const premiumFontCss = css `
  background: linear-gradient(
    91deg,
    var(--subscriptionGradientFrom-9) 10.52%,
    var(--subscriptionGradientTo-9) 122.56%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
export const boostersFontCss = css `
  background: linear-gradient(
    111deg,
    var(--boostGradientFrom-9) 17.4%,
    var(--boostGradientTo-9) 117.02%
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
`;
//# sourceMappingURL=premium-font-css.js.map